import config from "./config";
import Cti from "./isicom/CTIObject";
import io from "socket.io-client";
import agentStates from "./isicom/agentStates";
import commandAgentStates from "./isicom/commandAgentStates";

export default class Isicom {
    mapping = {
        CstaAlerting: (args) => {
            this.onCallAlert(args);
        },
        CstaClearCall: (args) => {
            this.onCallEnded(args);
        },
        AgentState: (args) => {
            this.onStatusChange(args);
        },
        AutomateCall: (args) => {
            this.onAutomateCall(args);
        },
        CstaEstablished: (args) => {
            this.onCallEstablished(args);
        },
        IdentificationAsked: (args) => {
            this.onIdentificationAsked(args);
        }
    };

    logs = "";

    constructor(options = {}) {
        this.options = options;
        this.init();
    }

    init = () => {
        this.socket = io.connect(config.isicom.ws_url, { path: "/ctiws/socket.io", forceNew: true, transports: ["websocket"], upgrade: false, secure: true });

        this.registerEvents();
    };

    registerEvents = () => {
        this.socket.on("connect", () => {
            this.registerAgent(this.options.agentId.toString());
        });

        this.socket.on("event", (data) => {
            this.addLog(JSON.stringify(data));

            try {
                const func = data.func;
                const args = JSON.parse(data.args);

                if (this.mapping[func]) {
                    this.mapping[func](args);
                }
            } catch (e) {
                console.warn("isicomOnEvent", e);
            }
        });

        this.socket.on("error", (error) => {
            console.log("error", error);
        });
    };

    isConnected = () => {
        return this.socket.connected;
    };

    getSocket = () => {
        return this.socket;
    };

    registerAgent = (id) => {
        return this.socket.emit("RegisterAgent", { agentNum: id });
    };

    makeCall = (phone) => {
        if (!this.isConnected()) {
            return false;
        }
        return this.socket.emit("MakeCall", { phoneNumberToDial: phone });
    };

    onCallAlert = (args) => {
        this.options.onCallAlert({
            id: args?.[1],
            agentId: args?.[0],
            from: args?.[2],
            to: args?.[3],
        });
        return true;
    };

    onCallEnded = (args) => {
        this.options.onCallEnded({
            id: args?.[1],
            agentId: args?.[0],
        });
    };

    onStatusChange = (args) => {
        const agentId = args?.[0];
        const statusNbr = args?.[1];

        const status = agentStates?.[statusNbr] ?? {};

        this.options.onStatusChange({
            agentId: agentId,
            status: status,
        });
    };

    onAutomateCall = (args) => {
        const agentId = args?.[0];
        const ticketId = args?.[1];
        const contactId = args?.[2];
        const customerId = args?.[3];

        this.options.onAutomateCall({
            agentId: agentId,
            ticketId: ticketId,
            contactId: contactId,
            customerId: customerId,
        });
    };

    onCallEstablished = (args) => {
        const agentId = args?.[0];
        const refCom = args?.[1];
        const from = args?.[2];
        const to = args?.[3];

        this.options.onCallEstablished({
            agentId: agentId,
            id: refCom,
            from: from,
            to: to,
        });
    };

    onIdentificationAsked = (args) => {
        const agentId = args?.[0];
        const refCom = args?.[1];
        const from = args?.[3];
        const to = args?.[2];

        this.options.onIdentificationAsked({
            agentId: agentId,
            id: refCom,
            from: from,
            to: to,
        })
    }

    setAgentStatus = (status) => {
        this.agentStatus = status;
    };

    changeAgentState = (state) => {
        this.socket.emit("ChangeAgentState", { cmdState: state.cmd_state.id, id_or_label: state.id });
    };

    answerCall = (id) => {
        this.socket.emit("srvAnswerCall", { refCom: parseInt(id), agentNum: "1001" });
        this.socket.emit("AnswerCall", { refCom: parseInt(id) });
    };

    hangUpCall = (id) => {
        this.socket.emit("srvClearCall", { refCom: parseInt(id), agentNum: "1001" });
        this.socket.emit("ClearCall", { refCom: id });
    };

    addLog = (data) => {
        this.logs += "\n" + data;
        sessionStorage.setItem("isicom_logs", this.logs);
    };

    clearlog = () => {
        this.logs = "";
        sessionStorage.removeItem("isicom_logs");
    };
}
